<div class="spinner">
  <svg class="spinner__svg" viewBox="25 25 50 50">
    <circle class="spinner__svg__circle" cx="50" cy="50" r="20" fill="none" stroke-width="5" />
  </svg>
</div>
